 $(window).on('load', function() {

// $('.popup_size').fadeOut({
//         duration: 1000,
//         start: function() {
//         		  $('.intr_popup').css('transform', 'scale(0.4)')
//         	}
//         });


  $("body").on("click","a.size_guide", function(e){
 e.preventDefault();
     setTimeout(function(){
       $('body').addClass('popup_open')
        $('.popup_size').fadeIn({
        duration: 1000,
        start: function() {
        		  $('.intr_popup').css('transform', 'scale(1)')
        	}
        });
     },100)
   })

     $("body").on("click",".clsoe_size", function(e){
  $('.popup_size').fadeOut({
        duration: 1000,
        start: function() {
        		  $('.intr_popup').css('transform', 'scale(0.4)')
            $('body').removeClass('popup_open')
        	}
        });

     })

   $('body').click(function(e) {
    if (!$(e.target).closest('body.popup_open .intr_popup').length){
       $('.popup_size').fadeOut({
        duration: 1000,
        start: function() {
        		  $('.intr_popup').css('transform', 'scale(0.4)')
            $('body').removeClass('popup_open')
        	}
        });
      
    }
});
 })